module.exports = __webpack_public_path__ + "media/images/icon__facebook@2x-9954a0137023161bd2038f799c58a2d8.png";